export enum BlockableFeature {
  CustomPlaceholders = "CUSTOM_PLACEHOLDERS",
  ArticleInjections = "ARTICLE_INJECTIONS",
  DiscordWebhooks = "DISCORD_WEBHOOKS",
}
